import AWS
    from 'aws-sdk'
import {
    CognitoUser,
    CognitoUserPool,
    CognitoRefreshToken,
} from 'amazon-cognito-identity-js';

/**
 *
 */
export default class Cognito implements Cognitable {

    /**
     *
     */
    credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: String(process.env.VUE_APP_COGNITO_IdentityPoolId),
    });

    userPool = new CognitoUserPool({
        UserPoolId: String(process.env.VUE_APP_COGNITO_UserPoolId),
        ClientId: String(process.env.VUE_APP_COGNITO_ClientId),
    });

    constructor() {
        AWS.config.region = String(process.env.VUE_APP_AWS_Region); // リージョン
    }

    refresh(userName: string, refreshToken: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const cognitoUser = new CognitoUser({
                Username: userName,
                Pool: this.userPool,
            });

            const ConvertedRefreshToken = new CognitoRefreshToken({RefreshToken: refreshToken});

            cognitoUser.refreshSession(ConvertedRefreshToken, (err, session) => {
                if (err) {
                    console.log(err);
                    reject(err);
                } else {
                    console.log(session);
                    this.credentials.refresh(err => {
                        if (err) {
                            console.log(err);
                            reject(err);
                        } else {
                            console.log('TOKEN SUCCESSFULLY UPDATED');
                            resolve(session);
                        }
                    });
                }
            });
        });
    }
}